<template>
    <div>
        <topnav @toaboutlangsi="juper" @hointop="hointop"></topnav>
 <div style="height: 100vh;width: 100vw;position: fixed;left: 0;top: 0;z-index: 1;overflow-y: scroll;" @touchstart='a' @wheel.passive="a"  id="nrbox">
<img src="../../src/img/topimg.png" class="topimg"  id="top" alt="">
<aboutlangsi id="aboutlangsi"></aboutlangsi>
<lk v-if="pmwidth>700" style="margin-top: 10px;"></lk>
</div>
    </div>
</template>
<script>
// import HelloWorld from './components/HelloWorld.vue'
import topnav from './topnav.vue'
import aboutlangsi from './aboutlangsi.vue'
import lk from './lk.vue'
export default {
  name: 'home',
  data() {
    return {
      pmwidth:document.body.clientWidth,//屏幕宽度
      scrollTop: 0, //默认距离顶部的距离
      isShow: false, //控制返回顶部按钮的显隐
      scrollTrigger: false, //默认初始值
    }
  },
  mounted () {//实时监控屏幕宽度
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.pmwidth = window.screenWidth
        })()
    }
},
  methods:{
    hointop(){
      this.$store.state.bgtop='rgba(0,0,0,0)'
        document.querySelector('#top').scrollIntoView(true)
      
    },
    juper(){
      this.$store.state.bgtop='rgba(0,0,0,0.8)'
        document.querySelector('#aboutlangsi').scrollIntoView(true)
    },
    a(){
      var ContainerElement = document.getElementById("nrbox");
      var y = ContainerElement.scrollTop;
      if(y>=300){this.$store.state.bgtop='rgba(0,0,0,0.8)'}
      else if(y>100&&y<300){
        this.$store.state.bgtop='rgba(0,0,0,0.4)'
      }else{
        this.$store.state.bgtop='rgba(0,0,0,0)'
      }
    }
  },
  components: {
    topnav,aboutlangsi,lk
  }
}
</script>
<style>

.app{
  padding: 0;
  margin: 0;
}
::-webkit-scrollbar{
      display: none;
    }
  .topimg{
    width: 100%;height: 100%;
  }
  @media screen and (max-width: 700px) {
    .topimg{
    width: 100%;height: 40%;
  }
  }
</style>